import React from 'react';
import PropTypes from 'prop-types';

export default function AiCoach({ score }) {
  return (
    <>
      <h2>Your Work Readiness Path</h2>

      <p>
        Your score:
        {score}
        {' '}
        points
      </p>
      <p>
        Great job completing your Health and Performance Assessment and AI coach debrief!
      </p>
      <h3>Continue with AI Coaching</h3>
      <p>
        Based on your results, you&apos;re eligible to continue working with your AI coach
        to support your work readiness journey.
      </p>
      <p>
        Your AI coach can help you:
        <ul>
          <li>Build on the insights from your assessment</li>
          <li>Create actionable steps for workplace reintegration</li>
          <li>Track your progress with regular check-ins</li>
        </ul>
      </p>

    </>
  );
}

AiCoach.propTypes = {
  score: PropTypes.number.isRequired,
};
